export default __webpack_public_path__ + "static/media/profile_female@3x.e2964d9d.png";